import { TextButton } from '@maersktankersdigital/web-components'
import { Box } from '@mui/material'
import { IQuestionnaireField } from '~api/vessels/read'
import { useGetFileUrl } from '~hooks/queries/files/use-get-file-url'
import { downloadFile } from '~pages/pages-behind-login/documents/document'

export function DownloadLink({ downloadLink, name }: IQuestionnaireField) {
  const { refetch: fetchDocumentUrl } = useGetFileUrl({
    documentId: downloadLink._id,
  })

  async function onClickHandler() {
    const { data } = await fetchDocumentUrl()
    if (!data?.signedUrl) return
    downloadFile({ url: data.signedUrl, title: name })
  }

  return (
    <Box
      component={TextButton}
      sx={{ textDecoration: 'underline', minWidth: '100%', mb: 2 }}
      onClick={onClickHandler}
    >
      {name}
    </Box>
  )
}
